import { keys, difference } from 'lodash';

const videoTextures = {};
class VideoSystem {
  constructor(systems) {
    this.systems = systems;
    this.videoCache = {}
    this.__videoCacheLen = 0;

    this.videoTextures = videoTextures;
  }

  before(dt) {
    this.videoHitKeys = [];
  }

  getVideoTexture(textureName) {
    const {controller,videoTexture} = this.systems.assets.getVideoController(textureName);
    return {
      controller,
      videoTexture
    }

  }

  update(dt, ent) {
    try {
      const uuid = ent.uuid.uuid;
      const cache = this.videoCache[uuid];
      if (!cache) {
        console.log('create video for', uuid);
        this.systems.addInnerContainer(ent.uuid.uuid, ent);

        const {videoTexture,controller} = this.getVideoTexture(ent.video.texture);
        console.log(ent.uuid.uuid, 'grab video texture', videoTexture.__number);
        const parent = this.systems.pixiContainers[ent.uuid.uuid].inner;
        //const debugText = new PIXI.Text('test', {fontFamily : 'Arial', fontSize: 48, fill : 0xff1010, align : 'center'});


        try {
          controller.play()
          //prm
            .then( () => {
              if (!ent || !ent.video) {
                return;
              }
              const textureWidth = ent.video.width;
              const textureHeight = ent.video.height;

              controller.currentTime = 0;

              console.log(uuid, ' i just played');
              const sprite = new PIXI.Sprite(videoTexture);
              sprite.scale.x = 1 / textureWidth;
              sprite.scale.y = 1 / textureHeight;
              sprite.position.set(0,0);
              sprite.anchor.x = ent.transform.anchorx;
              sprite.anchor.y = ent.transform.anchory;
              //sprite.alpha = 0.3;
              parent.addChild(sprite);

              //parent.addChild(debugText);
              //debugText.scale.x = sprite.scale.x;
              //debugText.scale.y = sprite.scale.y;

              this.videoCache[uuid].sprite = sprite;
            }, (err) => {
              if (!ent || !ent.video) {
                return;
              }
              console.log(uuid, 'le cache', this.videoCache[uuid].paused);
              if (!this.videoCache[uuid].paused) {
                this.systems.emitVideoPlayingPrompt(ent.video);
                console.error('error in this thing', err);
                console.log('type', typeof(err));
              }
            })
            .catch( (e) => {
              if (!ent || !ent.video) {
                return;
              }
              console.log(uuid, 'le cache2', this.videoCache.paused);
              if (this.videoCache[uuid] && !this.videoCache[uuid].paused) {
                this.systems.emitVideoPlayingPrompt(ent.video);
                console.error('error in the other thing', e);
                console.log('type', typeof(e));
              }
            })
        } catch (e) {
          if (!ent || !ent.video) {
            return;
          }
          console.error('am err', e);
          if (!this.videoCache[uuid].paused) {
            this.systems.emitVideoPlayingPrompt(ent.video);
            console.log('cant play', e);
            console.log('type', typeof(e));
          }
        }

        //if (true) {
          //this.systems.emitVideoPlayingPrompt(ent.video);
        //}

        /*
        const v = document.createElement('video');
        v.muted = true;
        v.loop = true;
        v.source = controller.source;
        document.body.appendChild(v)

        v.onload = () => {
          console.log('video loaded');
        }

        const videoTexture = PIXI.Texture.from(v);
        */


        this.videoCache[uuid] = {
          texture:ent.video.texture,
          videoTexture,
          controller,
          parent,
          t:0,
          lastTime:0,
          //debugText,
          playing:false,
          added:false
          //layer:layer,
          //group:group
        }
        this.__videoCacheLen++;

        const slots = this.systems.findSlots(ent, ent.video);
        this.systems.addComponent(ent, slots);

        this.systems.createSceneGraphChildren(ent, ent.transform);

      } /*else {
        cache.t += dt;
        const controller = cache.controller;
        controller.setAttribute("loop", true);
        if  (Math.abs(cache.lastTime - controller.currentTime) < 0.005) {
          //controller.currentTime = 0;
          //controller.play();
          //cache.lastTime = 0;
          this.systems.forceSetDirty(ent);
          cache.lastTime = controller.currentTime;
        } else {
          if (controller.currentTime >= controller.duration) {
            controller.currentTime = 0;
            cache.debugText.text = 'R'+controller.currentTime.toFixed(2);
          } else {
            cache.debugText.text = ''+controller.currentTime.toFixed(2);
          }
          cache.lastTime = controller.currentTime;
        }
        //if (controller.currentTime >= controller.duration) {
          //controller.currentTime = 0;
          //controller.play();
        //}
      }*/

      this.videoHitKeys.push(uuid);
    } catch (e) {
      console.error('moar err', e);
      this.systems.emitVideoPlayingPrompt(ent.video);
    }

  }

  after(dt) {
    const hitKeys = this.videoHitKeys;
    if (this.__videoCacheLen !== hitKeys.length) {
      const toRemove = difference(keys(this.videoCache), hitKeys);
      const toRemoveLength = toRemove.length;
      for (let i = 0; i < toRemoveLength; i++) {
          const uuid = toRemove[i];
          console.log('remove video for', uuid);
          if (!this.videoCache[uuid]) {
            console.error('no video found for', uuid);
            continue;
          }
          const cache = this.videoCache[uuid];
          const sprite = cache.sprite;
          //this.systems.returnToPool(this.videoCache[uuid].texture, sprite, this.videoCache[uuid].parent);

          cache.paused = true;
          if (sprite) {
            cache.parent.removeChild(sprite);
            cache.sprite.destroy();
          }
          this.videoCache[uuid].paused = true;
          //this.videoCache[uuid].videoTexture.baseTexture.destroy();
          //this.videoCache[uuid].videoTexture.destroy();

          delete this.videoCache[uuid];
          this.__videoCacheLen--;
      }
    }
  }
}

export default VideoSystem;
